import React from 'react';

import ICO_CLOSE from 'assets/images/close-btn-black.svg';

import Button from 'settings/page-elements/Button';

import 'styles/common/confirmation-modal.scss';

// DEPRECATED: use components/dialog/SalonModal.component
const ConfirmationModal = ({
  btnClose,
  btnConfirmName,
  btnDiscardName,
  children,
  closeModal,
  confirm,
  disabled,
  discard,
  popupMessage,
  popupTitle,
}) => (
  <div data-bem="ConfirmationModal--settings">
    <div className="overlay" />
    <div className="confirmation-modal animated zoomIn">
      <div className="modal-body">
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
        <span className={btnClose ? 'close hidden' : 'close'} onClick={closeModal}>
          <img src={ICO_CLOSE} alt="Close modal" />
        </span>
        <h2 className="modal-title"> {popupTitle}</h2>

        <div className="modal-content">
          {popupMessage}
          {children}
        </div>
        <div className="modal-footer">
          <Button className="btn-violet-link" buttonName={btnDiscardName} onClickButton={discard} />
          <Button className="btn-violet-link" buttonName={btnConfirmName} onClickButton={confirm} disabled={disabled} />
        </div>
      </div>
    </div>
  </div>
);

ConfirmationModal.defaultProps = {
  btnDiscardName: '',
  btnConfirmName: '',
  children: [],
};

export default ConfirmationModal;
